import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getEventFormSteps = (id) => {
    return vdkEmHappinessPortalApi.get(`/get-dashboard-form-steps-by-eventId/${id}`);
};
const getEventFormStepFields = (id) => {
    return vdkEmHappinessPortalApi.get(`/get-dashboard-step-fields-by-stepId/${id}`);
};
const getEventFormStepsAndFields = (id) => {
    return vdkEmHappinessPortalApi.get(`/get-dashboard-form-steps-and-fields-by-eventId/${id}`);
};
const updateDashboardResponseGrid = (data) => {
    return vdkEmHappinessPortalApi.put(`/update-dashboard-fields`, data);
};
const eventDashboardApi = {
    getEventFormSteps,
    getEventFormStepFields,
    getEventFormStepsAndFields,
    updateDashboardResponseGrid
};
export default eventDashboardApi;
